import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Product } from '../../../Model/Catalog/Product';
import { Catalog } from '../../../Model/Catalog/Catalog';
import { ValidationService } from '../../../Services/Validation/validation.service';
import { CatalogService } from '../../../Services/CatalogManagement/catalog.service';
import { UserManagementService } from '../../../Services/userManagment.service';
import { ProductScireum } from '../../../Model/Catalog/scireum/ProductScireum';
import { fieldNames } from 'app/Model/FieldNames';
import { LoginService } from '../../../Services/login.service';

@Component({
    selector: 'np-product-scireum',
    templateUrl: './product-scireum.component.html',
    styleUrls: ['./product-scireum.component.css'],
    standalone: false
})
export class ProductScireumComponent {
  @Input() model: Product = new Product();
  @Input() templateView: Boolean = false;
  @Input() selectedElements: string[] = [''];
  @Input() showDragHandle: boolean = false;
  @Input() dragFilter: string = 'noDrag';


  @Output() elementSelected = new EventEmitter<string>();
  @Output() excelElementDropped = new EventEmitter<any>();
  @Output() onValueChanged = new EventEmitter<any>();

  
  batteriepiktogrammAray: number[] = [3480, 3481, 3090, 3091, NaN]
  befoerderungskategorieArray: number[] = [0, 1, 2, 3, 4]
  gefahrgutKlassenArray: string[] = ["1", "2.1", "2.2", "2.3", "3", "4.1", "4.2", "4.3", "5.1", "5.2", "6.1", "6.2", "7", "8", "9"]
  gefahrenzettelArray: string[] = ["1", "1.1", " 1.2", "1.3", " 1.4", "1.5", " 1.6", "2.1", " 2.2", " 2.3", "3", " 4.1", "4.2", "4.3", "5.1", "5.2", "6.1", "6.2",
    "7A", "7B", "7C", " 7E", "8", "9", "9A"]
  gefahrgutVerpackungsgruppeArray: string[] = ["I", "II", "III"]
  get fieldNames (){
    return fieldNames;
  }

  constructor(
    public translate: TranslateService,
    public validationService: ValidationService,
    public catalogService: CatalogService,
    public userManagementService: UserManagementService,
    public loginService: LoginService
  ) { }

  async ngOnInit(): Promise<void> {
    this.model.scireum ??= new ProductScireum();
  }

  update(event = null, field?: string, system: string = '-1', element: string = '-1') {
    if (event) {
      event.dField = field;
      event.dSystem = system;
      event.dElement = element;      
      event.createTemplateItem = true;
    }
    this.onValueChanged.emit(event);
  }

  showClearButton(): boolean {
    return !this.templateView;
  }

  public elementSelectFunction(event) {
    this.elementSelected.emit(event);
  }

  public excelElementDrop(e) {
    this.excelElementDropped.emit(e);
  }

  readOnly(name: string, catalog: Catalog = this.catalogService.catalog): boolean {
    return this.catalogService?.catalog?.isVirtual || !this.userManagementService.canEdit(name, catalog);
  }

  public readOnlyForLinkedFields(field: string, system: string = '-1', element: string = '-1'): boolean {
    // Wenn dies ein vom Master vererbtes Feld ist, soll es ReadOnly sein:
    if (field != null) {
      var isLinked = this.model.isFieldLinked(field, system, element);
      if (isLinked && this.model.isChild != null && this.model.isChild) {
        // Für einen Master darf es nicht ReadOnly werden!!
        return true;
      }
    }

    //return this.readOnly(productId);

    return false;
  }

}
